//SIDEBAR admin

import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FaHome, FaUsers, FaQuestionCircle, FaRegChartBar, FaSeedling } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2';
import { RiCommunityLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';

import logo from '../../Assets/DisaLogo.png';
import logo2 from '../../Assets/Logo.png';
import dropDown from '../../Assets/template/overview.png';
import vmo from '../../Assets/template/vmo.jpg';
import adminBg from '../../Assets/bg/adminbg.jpg';

const SidebarBohol = ({ onSelect, selectedContent, onToggleSidebar, darkMode }) => {
  const [isSidebarExpanded, setSidebarExpanded] = useState(true);
  const sidebarRef = useRef();
  const [isHomeHovered, setIsHomeHovered] = useState(false);
  const [isHelpHovered, setIsHelpHovered] = useState(false);
  const [isConvergenceHovered, setIsConvergenceHovered] = useState(false);
  const [isTemplateHovered, setIsTemplateHovered] = useState(false);
  const [isDAHovered, setIsDAHovered] = useState(false);
  const [isRsbaDropdownVisible, setRsbaDropdownVisible] = useState(false);
  const [isCoopDropdownVisible, setCoopDropdownVisible] = useState(false);
  const [isSlpDropdownVisible, setSlpDropdownVisible] = useState(false);
  const [isProfilingHovered, setIsProfilingHovered] = useState(false);
  const [profilingDropdownVisible, setProfilingDropdownVisible] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const navigate = useNavigate();

  const profilingOptions = [
    { label: 'CIS', value: 'CIS' },
    { label: 'NIS', value: 'NIS' },
    { label: 'SRIP', value: 'SRIP' },
    { label: 'SIS/SIP', value: 'SIS/SIP' },
    { label: 'PIP', value: 'PIP' },
  ];
  const isProfilingActive = profilingOptions.some(option => option.value === selectedContent);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target) && isSidebarExpanded) {
        setSidebarExpanded(false);
        onToggleSidebar(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSidebarExpanded, onToggleSidebar]);

  const toggleSidebar = () => {
  const newState = !isSidebarExpanded;
  setSidebarExpanded(newState);
  onToggleSidebar(newState);

  // 🔁 Automatically hide ALL dropdowns when collapsed
  if (!newState) {
    setProfilingDropdownVisible(false);
    setRsbaDropdownVisible(false);
    setCoopDropdownVisible(false);
    setSlpDropdownVisible(false);
  }
};

  const handleProfilingSelect = (target) => {
    setProfilingDropdownVisible(false);
    setRsbaDropdownVisible(false);
    setCoopDropdownVisible(false);
    setSlpDropdownVisible(false);
    onSelect(target);
  };


  useEffect(() => {
    const flipInterval = setInterval(() => {
      setIsFlipped(prev => !prev);
    }, 3000);
    return () => clearInterval(flipInterval);
  }, []);

  return (
    <SidebarContainer darkMode={darkMode} isExpanded={isSidebarExpanded} ref={sidebarRef}>
      <HeaderSection>
        <LogoContainer>
          <LogoFlipContainer>
            <LogoFlipper isFlipped={isFlipped}>
              <LogoFront src={logo} alt="Logo Front" />
              <LogoBack src={logo2} alt="Logo Back" />
            </LogoFlipper>
          </LogoFlipContainer>
          {isSidebarExpanded && <LogoText>DISA</LogoText>}
        </LogoContainer>
        <HamburgerMenu onClick={toggleSidebar}>
          {isSidebarExpanded ? <HorizontalHamburgerIcon /> : <VerticalHamburgerIcon />}
        </HamburgerMenu>
      </HeaderSection>

      <Line />

      <NavLinks>
        <NavItem
  onClick={() => {
    onSelect('HomeBohol');
    setProfilingDropdownVisible(false);
    setRsbaDropdownVisible(false);
    setCoopDropdownVisible(false);
    setSlpDropdownVisible(false);
  }}
  active={selectedContent === 'HomeBohol'}
  onMouseEnter={() => {
  if (selectedContent !== 'HelpAdmin') {
    setIsHomeHovered(true);
  }
}}
onMouseLeave={() => setIsHomeHovered(false)}
>
  <NavIcon as={FaHome} active={selectedContent === 'HomeBohol'} isExpanded={isSidebarExpanded} />
  {isSidebarExpanded ? <NavText>Home</NavText> : isHomeHovered && <Tooltip>Home</Tooltip>}
</NavItem>

        {/* ✅ Updated Profiling Logic */}
       <ProfilingContainer
  onMouseEnter={() => {
    if (!isSidebarExpanded && selectedContent !== 'HelpAdmin') {
      setIsProfilingHovered(true);
    }
  }}
  onMouseLeave={() => {
    if (!isSidebarExpanded) {
      setIsProfilingHovered(false);
    }
  }}
>
  <NavItem
    onClick={() => {
      setProfilingDropdownVisible(prev => !prev);
      setRsbaDropdownVisible(false);
      setCoopDropdownVisible(false);
      setSlpDropdownVisible(false);
    }}
    active={isProfilingActive}
  >
    <NavIcon isExpanded={isSidebarExpanded} as={FaUsers} active={isProfilingActive} />
    {isSidebarExpanded && <NavText>Profiling▾</NavText>}
  </NavItem>
  {(profilingDropdownVisible || (!isSidebarExpanded && isProfilingHovered)) && (
    isSidebarExpanded ? (
      <DropdownLineWrapper>
        <DropdownInline isExpanded={true}>
          {profilingOptions.map(option => (
            <DropdownItem key={option.value} onClick={() => handleProfilingSelect(option.value)}>
              {option.label}
            </DropdownItem>
          ))}
        </DropdownInline>
      </DropdownLineWrapper>
    ) : (
      <DropdownRight>
        {profilingOptions.map(option => (
          <DropdownItems key={option.value} onClick={() => handleProfilingSelect(option.value)}>
            {option.label}
          </DropdownItems>
        ))}
      </DropdownRight>
    )
  )}
</ProfilingContainer>

        {/* === Everything below remains unchanged === */}

   <ProfilingContainer
  onMouseEnter={() => {
    if (!isSidebarExpanded && selectedContent !== 'HelpAdmin') {
      setRsbaDropdownVisible(true);
    }
  }}
  onMouseLeave={() => {
    if (!isSidebarExpanded) {
      setRsbaDropdownVisible(false);
    }
  }}
>

</ProfilingContainer>


        <ProfilingContainer
  onMouseEnter={() => {
    if (!isSidebarExpanded && selectedContent !== 'HelpAdmin') {
      setCoopDropdownVisible(true);
    }
  }}
  onMouseLeave={() => {
    if (!isSidebarExpanded) {
      setCoopDropdownVisible(false);
    }
  }}
>

</ProfilingContainer>

        <ProfilingContainer
  onMouseEnter={() => {
    if (!isSidebarExpanded && selectedContent !== 'HelpAdmin') {
      setSlpDropdownVisible(true);
    }
  }}
  onMouseLeave={() => {
    if (!isSidebarExpanded) {
      setSlpDropdownVisible(false);
    }
  }}
>
 
</ProfilingContainer>

        <NavItem
  onClick={() => {
    onSelect('Convergence');
    setProfilingDropdownVisible(false);
    setRsbaDropdownVisible(false);
    setCoopDropdownVisible(false);
    setSlpDropdownVisible(false);
  }}
  active={selectedContent === 'Convergence'}
  onMouseEnter={() => setIsConvergenceHovered(true)}
  onMouseLeave={() => setIsConvergenceHovered(false)}
>
  <NavIcon
    isExpanded={isSidebarExpanded}
    as={FaRegChartBar}
    active={selectedContent === 'Convergence'}
  />
  {isSidebarExpanded ? (
    <NavText>Convergence</NavText>
  ) : (
    isConvergenceHovered && <Tooltip>Convergence</Tooltip>
  )}
</NavItem>

        <NavItem
  onClick={() => {
    onSelect('IaManagement');
    setProfilingDropdownVisible(false);
    setRsbaDropdownVisible(false);
    setCoopDropdownVisible(false);
    setSlpDropdownVisible(false);
  }}
  active={selectedContent === 'IaManagement'}
  onMouseEnter={() => setIsDAHovered(true)}
  onMouseLeave={() => setIsDAHovered(false)}
>
  <NavIcon
    isExpanded={isSidebarExpanded}
    as={HiOutlineBuildingOffice2}
    active={selectedContent === 'IaManagement'}
  />
  {isSidebarExpanded ? (
    <NavText>IA Management</NavText>
  ) : (
    isDAHovered && <Tooltip>IA Management</Tooltip>
  )}
</NavItem>

        <NavItem
  onClick={() => {
    onSelect('HelpAdmin');
    setProfilingDropdownVisible(false);
    setRsbaDropdownVisible(false);
    setCoopDropdownVisible(false);
    setSlpDropdownVisible(false);
  }}
  active={selectedContent === 'HelpAdmin'}
  onMouseEnter={() => {
  if (selectedContent !== 'HelpAdmin') {
    setIsHelpHovered(true);
  }
}}
onMouseLeave={() => setIsHelpHovered(false)}
>
  <NavIcon
    isExpanded={isSidebarExpanded}
    as={FaQuestionCircle}
    active={selectedContent === 'HelpAdmin'}
  />
  {isSidebarExpanded ? <NavText>Help</NavText> : isHelpHovered && <Tooltip>Help</Tooltip>}
</NavItem>

        <NavItem
  onClick={() => {
    onSelect('Template');
    setProfilingDropdownVisible(false);
    setRsbaDropdownVisible(false);
    setCoopDropdownVisible(false);
    setSlpDropdownVisible(false);
  }}
  active={selectedContent === 'Template'}
  onMouseEnter={() => setIsTemplateHovered(true)}
  onMouseLeave={() => setIsTemplateHovered(false)}
>
  <NavIcon
    as={FiDownload}
    active={selectedContent === 'Template'}
    isExpanded={isSidebarExpanded}
  />
  {isSidebarExpanded ? (
    <NavText>Template</NavText>
  ) : (
    isTemplateHovered && <Tooltip>Template</Tooltip>
  )}
</NavItem>
      </NavLinks>
    </SidebarContainer>
  );
};

export default SidebarBohol;

// 🧱 All your styled-components stay the same as your current code.

const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ isExpanded }) => (isExpanded ? 'center' : 'flex-start')};
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : `url(${vmo})`)};
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${({ isExpanded }) => (isExpanded ? '180px' : '60px')};
  z-index: 1000;
  height: 100vh;
  padding-top: 5px;
  transition: width 0.2s ease;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({ darkMode }) =>
      darkMode ? 'transparent' : 'linear-gradient(45deg, rgb(13, 207, 55), rgb(13, 110, 9))'};
    z-index: -1;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const LogoFlipContainer = styled.div`
  perspective: 800px;
  width: 45px;
  height: 45px;
`;

const LogoFlipper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 1s ease-in-out;
  transform-style: preserve-3d;
  transform: ${({ isFlipped }) => (isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)')};
`;

const LogoFace = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  object-fit: contain;
`;

const LogoFront = styled(LogoFace)``;

const LogoBack = styled(LogoFace)`
  transform: rotateY(180deg);
`;


const LogoText = styled.span`
  font-size: 13px;
  font-weight: bold;
  color: rgb(222, 226, 224);
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
`;

const HamburgerMenu = styled.div`
  cursor: pointer;
  marginTop: 30px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgb(241, 235, 235);
  margin: 5px 0;
`;

const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const NavItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
 background: ${({ active }) =>
  active ? 'rgba(243, 247, 245, 0.7)' : 'transparent'};
  border: none;
  cursor: pointer;
  padding: 12px;
  width: 100%;
  color: ${({ active }) => (active ? '#34ff74' : 'rgb(222, 226, 224)')};
  position: relative;
  justify-content: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'flex-start' : 'flex-start')};

  &:hover ${'' } {
    color: #76ff03;
  }
`;

const NavIcon = styled.div`
  font-size: ${({ isExpanded }) => (isExpanded ? '18px' : '18px')};
  margin-right: 15px;
  border-radius: 50%;
  color: ${({ active }) =>
    active
      ? 'linear-gradient(45deg, #00e676, #76ff03)'
      : '#f8fcfa'};
   background: ${({ active }) =>
    active ? 'linear-gradient(135deg, #00e676,rgb(205, 223, 218))' : 'transparent'};
 transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
`;


const NavText = styled.span`
  font-size: 15px;
  color: #f8fcfa;
  margin-left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '0px' : '0')};
`;

const ProfilingContainer = styled.div`
  position: relative;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 18px;
 
  width: ${({ isExpanded }) => (isExpanded ? "113%" : "250%")};
  border-radius: 3px;
  z-index: 1000;
  margin-top: 1px;
  margin-left: ${({ isExpanded }) => (isExpanded ? "100px" : "40px")};
`;

const DropdownInline = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 19px; /* reduce padding to move items closer to the line */
  padding-top: 4px;
  padding-bottom: 4px;

  &::before {
    content: '';
    position: absolute;
    left: 4px; /* move vertical line closer to items */
    top: 0;
    bottom: 0;
    width: 1.5px;
    background-color: #f4f4f4;
  }
`;

const DropdownItem = styled.button`
  position: relative;
  padding: 6px 12px 6px 20px;
  border: none;
  gap: 6px;
  color:#2e7d32;
  text-align: left;
  font-size: 13px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2e7d32;
    color: white;
  }

  &::before {
    content: '';
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 1.5px;
    background-color: #f4f4f4;
  }

  /* ✅ This ensures all children like <span>, etc., get the color */
  * {
    color: inherit !important;
  }
`;

const DropdownItems = styled.button`
  position: relative;
  padding: 6px 12px 6px 20px;
  border: none;
  gap: 6px;
  color:#2e7d32;
  text-align: left;
  font-size: 13px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2e7d32;
    color: white;
  }

  &::before {
    content: '';
    position: absolute;
    left: -10px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 1.5px;
    background-color:  #2e7d32;
  }

  /* ✅ This ensures all children like <span>, etc., get the color */
  * {
    color: inherit !important;
  }
`;

const DropdownSubItem = styled(DropdownItem)`
  padding-left: 35px;

  &::before {
    left: -22px;
  }
`;

const DropdownLineWrapper = styled.div`
  position: relative;
  padding-left: 19px;
  margin-left: 4px;
`;

const DropdownRight = styled.div`
  position: absolute;
  top: 0;
  left: 60px; /* right of collapsed sidebar */
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  min-width: 160px;
`;

const Tooltip = styled.span`
  position: absolute;
  left: 40px;
  background-image: linear-gradient(rgba(78, 151, 78, 0.5), rgba(0, 0, 0, 0.5)), url(${dropDown});
  color: white;
  padding: 5px 5px;
  border-radius: 2px;
  font-size: 12px;
  white-space: nowrap;
  transition: opacity 0.3s ease-in-out;
  opacity: 0.9;
  z-index: 1000;
`;

const HorizontalHamburgerIcon = () => (
  <div style={{ display: 'flex', flexDirection: 'row', gap: '7px' }}>
    <div style={{ width: '2px', height: '16px', marginTop: '10px', backgroundColor: '#f8fcfa' }}></div>
    <div style={{ width: '2px', height: '16px', marginTop: '10px', backgroundColor: '#f8fcfa' }}></div>
  </div>
);

const VerticalHamburgerIcon = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '18px', height: '15px', marginTop: '10px' }}>
    <div style={{ height: '2px', backgroundColor: '#f8fcfa', width: '100%' }}></div>
    <div style={{ height: '2px', backgroundColor: '#f8fcfa', width: '100%' }}></div>
  </div>
);

//SidebarAdmin.js